export const SUPPORTED_LOCALES = ["en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en";
export const isMultiLocale = SUPPORTED_LOCALES.length > 1;
export const WEB_NAMESPACES = ["common", "auth", "landing", "dashboard", "seo"] as const;
export const NATIVE_NAMESPACES = ["common", "auth", "native"] as const;
export const DEFAULT_NS = "common";

export const LOCALE_META: Record<string, { flag: string; name: string; htmlLang: string }> = {
  en: { flag: "\u{1F1EC}\u{1F1E7}", name: "English", htmlLang: "en" },
};
